import { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from './input';
import { cn } from '@/lib/utils';

// Password field with a show/hide eye toggle so users can verify spelling.
// Drop-in replacement for <Input type="password" />. Pass `testId` to get a
// data-testid on the input and `${testId}-toggle` on the eye button.
export const PasswordInput = forwardRef(({ className, testId, ...props }, ref) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative w-full">
      <Input
        ref={ref}
        type={show ? 'text' : 'password'}
        className={cn('pr-10', className)}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Hide password' : 'Show password'}
        data-testid={testId ? `${testId}-toggle` : 'password-toggle'}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';
